import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';
import * as Highcharts from 'highcharts';

import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Placeholder } from '@process-advisor/process-miner/slicers/variants/placeholder';
import { HighChart } from '@process-advisor/process-miner/slicers/variants/highChart';
import { SingleBlock } from '@process-advisor/process-miner/slicers/variants/singleBlock';
import { Section } from '@process-advisor/process-miner/slicers/variants/section';
import { SelectAction } from '@process-advisor/process-miner/slicers/variants/selectAction';

export type Data = []
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

const SingleBlockRow = styled(SingleBlock)`
    flex-direction: row
`;

export const VariantsChart: React.FC = React.memo(() => {
    const [data, setData] = React.useState<Data[]>([]);

    React.useEffect(() => {
        
        const applySlicerListener = () =>
            apiProvider.updateVariantSlicerVariantChart({});
        const listener = (props) => {

            const temp = []   
            for (let i = 0; i < props.length; i++) {
                const valueToPush = {};
                valueToPush["name"] = props[i].s;
                valueToPush["y"] = props[i].t;
                valueToPush["variant"] = props[i].n;
                temp.push(valueToPush);
            }    
            setData(temp);
        };
        apiProvider.on(Event.updateVariantSlicerVariantChart, listener);
        apiProvider.on(Event.setActionBar_Visualizer, applySlicerListener);     
        setTimeout(() => apiProvider.updateVariantSlicerVariantChart({}));

        return () => {
            apiProvider.off(Event.updateVariantSlicerVariantChart, listener);
            apiProvider.off(Event.setActionBar_Visualizer, applySlicerListener);            
        };
    }, []);

    const options: Highcharts.Options = {
        chart: {
            height: 275,
            type: 'bar',
            style: {
                fontFamily: 'system-ui'
            }
        },
        
        title: {
            text: ''
        },
        exporting: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            title: {
                text: null,
            },
            min: 0,
            max: Math.min(data.length - 1, 9),
            scrollbar: {
                enabled: true,
            },
            tickLength: 0,
        },
        tooltip: {
            pointFormat: '{point.variant}',
        },
        yAxis: {
            title: {
                text: '',
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                shadow: true,
                dataLabels: {
                    enabled: true,
                    formatter () {
                        return Highcharts.numberFormat(this.y, null, null, ',');
                    },
                    style: {
                        fontWeight: 'normal',
                    },
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                type: 'column',
                color: '#187bcd',
                pointWidth: 18,
                dataSorting: {
                    enabled: true,
                    sortKey: 's',
                },
                data,
                name: 'Variant',
                cursor: 'pointer',
                point: {
                    events: {
                        click: function() {
                            const variant = parseInt(this.name)
                            apiProvider.selectVariant({pane: SidebarTab.variantsTab,variant})
                        }
                    }
                }

                
            },
        ],
    };



    if (_.isEmpty(data)) {
        return (
            <Wrapper>
                <Placeholder>
                    Select one or more variants
                </Placeholder>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <HighChart options={options} />
            <SingleBlock width="20%">
                <Section title='Select Action'/>
            </SingleBlock>
            <SingleBlockRow width="80%">
                <SelectAction />
            </SingleBlockRow>
        </Wrapper>

    );
});
